import { twMerge } from "tailwind-merge"

const ButtonLabel: React.FC<React.HTMLAttributes<HTMLSpanElement>> = ({ className, ...props }) => {
  return <span className={twMerge("font-sans font-bold text-gray-80", className)} {...props} />
}

export default ButtonLabel
